import axios from "./axios";
export async function catalogComplexesIndex(params) {
    try {
        const response =  await axios.get('/api/v1/complexes', {params})
        if(response?.status === 200 && Array.isArray(response?.data?.data)) return response.data.data
        return []
    } catch (e) {
        console.error(e)
    }
}
export async function catalogPropertiesIndex(params) {
    try {
        const response =  await axios.get('/api/v1/properties-for-sale', {params})
        if(response?.status === 200 && Array.isArray(response?.data?.data)) return response.data.data
        return []
    } catch (e) {
        console.error(e)
    }
}
export async function countProperties(params) {
    try {
        const response = await axios.get('/api/v1/properties-for-sale/count', {params})
        if (response?.status === 200 && typeof response?.data?.count === 'number') return response.data.count
        return null
    } catch (e) {
        console.error(e)
        return null
    }
}
export async function countComplexes(params) {
    try {
        const response = await axios.get('/api/v1/complexes/count', {params})
        if (response?.status === 200 && typeof response?.data?.count === 'number') return response.data.count
        return null
    } catch (e) {
        console.error(e)
        return null
    }
}
